<template>
    <BreadCrumb PageTitle="Modifier" />
    <EditAssignation/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditAssignation from "@/components/Assignations/EditAssignation.vue";
  
    export default defineComponent({
      name: "EditAssignationPage",
      components: {
        BreadCrumb,
        EditAssignation,
      },
    });
  </script>